export const getVrpDetectStatistic = (recognized: number, notRecognized: number) =>
  recognized / (recognized + notRecognized);
